import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadCsvIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 10.862,
	height: 11.586,
	viewBox: "0 0 10.862 11.586",
	fill: "#2C3B45",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-16)",
		children: [/* @__PURE__ */ _jsx("g", {
			transform: "translate(18.534)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M133.759,5.281a.361.361,0,0,0-.329-.212h-1.448V.362A.362.362,0,0,0,131.619,0h-1.448a.362.362,0,0,0-.362.362V5.069H128.36a.362.362,0,0,0-.272.6l2.535,2.9a.361.361,0,0,0,.545,0l2.535-2.9A.361.361,0,0,0,133.759,5.281Z",
				transform: "translate(-127.998)"
			})
		}), /* @__PURE__ */ _jsx("g", {
			transform: "translate(16 7.966)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M25.414,352v2.172H17.448V352H16v2.9a.724.724,0,0,0,.724.724h9.414a.723.723,0,0,0,.724-.724V352Z",
				transform: "translate(-16 -352)"
			})
		})]
	})
});
export default SvgDownloadCsvIcon;
